<template>
  <div>
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <!--Diagnoses   **********************************************************************************-->
    <v-dialog v-model="diagnosisBaseDataModal" persistent width="760">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-pencil</v-icon>
              <span class="modal-title-text mr-2">ویرایش سانتر ها</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text>
          <v-row class="mt-8">
            <span class="dialog-part-divider-text">سانتر ها</span>
            <v-divider class="mt-2 mr-3"></v-divider>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card elevation="0" height="26vh" class="inside-cards">
                <v-card-text>
                  <v-chip class="mr-3 chip-text" label v-for="item in allHospitalDiagnosisBaseDatas" :key="item.id">
                    {{ item.title }}
                    <v-icon right @click="addDiagnoToHospitalDiagnos(item)" color="darkColor">
                      mdi-plus
                    </v-icon>
                  </v-chip>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <span class="dialog-part-divider-text">سانتر های انتخابی</span>
            <v-divider class="mt-2 mr-3"></v-divider>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card elevation="0" height="26vh" class="inside-cards">
                <v-card-text>
                  <v-chip class="mr-3" label v-for="item in allHospitalSelectedDiagnosisBaseDatas" :key="item.id"
                    color="darkColor" dark>
                    {{ item.title }}
                    <v-icon right @click="removeDiagnoFromHospitalDiagnos(item)">mdi-close</v-icon>
                  </v-chip>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="setHospitalDiagno()" dark rounded class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancleEditHospitalDiagno()"
            class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="450" v-model="searchModal">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-magnify</v-icon>
              <span class="modal-title-text mr-2">جستجو</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-12">
          <v-row>
            <v-col cols="12">
              <v-autocomplete :items="allCitysForOther" no-data-text="اطلاعاتی وجود ندارد" tabindex="1" dense outlined
                clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id" label="شهرستان"
                :autofocus="true" v-model="searchCityId" autocomplete="off" prepend-inner-icon="mdi-home-city mdi-18px"
                style="font-size: 11px !important"></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-text-field type="text" v-model="searchText" dense clearable clear-icon="mdi-close-circle-outline"
                outlined v-on:keyup.enter="search()" label="نام بیمارستان" class="input-label"
                prepend-inner-icon="mdi-hospital-building mdi-18px" tabindex="2"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="search()" dark rounded class="normal-letter-spacing px-12">
            جستجو
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelSearch()" class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="900" v-model="showAddEditModal" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">{{ modalIcon }}</v-icon>
              <span class="modal-title-text mr-2">{{ modalTitle }}</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-12">
          <v-row>
            <v-col :cols="addFlag ? 4 : 6">
              <v-autocomplete :items="allCitysForOther" no-data-text="اطلاعاتی وجود ندارد" tabindex="1" dense outlined
                clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                @change="getCityGeoLocation()" label="شهرستان*" :autofocus="true" v-model="hospital.cityId"
                autocomplete="off" prepend-inner-icon="mdi-home-city mdi-18px" hide-details
                style="font-size: 11px !important"></v-autocomplete>
            </v-col>
            <v-col :cols="addFlag ? 4 : 6">
              <v-text-field type="text" v-model="hospital.title" dense clearable clear-icon="mdi-close-circle-outline"
                outlined v-on:keyup.enter="showConfirmDialogFunction()" label="نام بیمارستان*" class="input-label"
                hide-details prepend-inner-icon="mdi-hospital-building mdi-18px" tabindex="2"></v-text-field>
            </v-col>
            <v-col cols="4" v-if="addFlag">
              <v-autocomplete :items="allDiagnosisBaseDatas" no-data-text="اطلاعاتی وجود ندارد" tabindex="4" dense
                outlined clearable multiple clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                hide-details label="سانتر" v-model="hospital.hospitalDiagnosisIds" autocomplete="off"
                prepend-inner-icon="mdi-stethoscope mdi-18px"></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-text-field type="text" clearable clear-icon="mdi-close-circle-outline" v-model="hospital.sepasCode"
                dense outlined v-on:keyup.enter="showConfirmDialogFunction()" label="شناسه سیام" class="input-label"
                hide-details prepend-inner-icon="mdi-unicode mdi-18px" tabindex="3"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field type="text" clearable clear-icon="mdi-close-circle-outline" v-model="hospital.address" dense
                outlined v-on:keyup.enter="showConfirmDialogFunction()" label="آدرس" class="input-label" hide-details
                prepend-inner-icon="mdi-map-marker mdi-18px" tabindex="3"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" v-for="(item, index) in hospitalphoneNumbers" :key="item.id">
              <v-text-field type="text" v-model="item.text" dense clearable clear-icon="mdi-close-circle-outline"
                maxlength="11" @keypress="isNumber($event)" append-outer-icon="mdi-close" hide-details
                @click:append-outer="removePhoneNumber(item.id)" outlined v-on:keyup.enter="showConfirmDialogFunction()"
                label="شماره تلفن" class="input-label" prepend-inner-icon="mdi-phone mdi-flip-h mdi-18px"
                :tabindex="index + 5"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-card elevation="0" class="card-add-phoneNumber" @click="addPhoneNumber()">
                <v-card-text>
                  <v-row class="card-add-phoneNumber-items">
                    <v-icon color="#CDCBCF" class="mr-2">mdi-phone mdi-flip-h mdi-18px</v-icon>
                    <span class="mr-3 card-add-phoneNumber-items-text">شماره تلفن</span>
                    <v-spacer></v-spacer>
                    <v-icon color="#212121">mdi-plus mdi-18px</v-icon>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <span>موقعیت</span>
            <v-divider class="mt-2 mr-3"></v-divider>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div id="map">
                <l-map v-if="isMapReadyToShow" ref="modalmap" style="height: 45vh !important" @click="addMarker"
                  :zoom="zoom" :center="center" :options="mapOptions" @update:center="centerUpdate"
                  @update:zoom="zoomUpdate" @ready="mapInvalidate()">
                  <l-tile-layer :url="mapTileUrl" :attribution="attribution"></l-tile-layer>
                  <!--<v-geosearch :options="geosearchOptions"></v-geosearch>-->
                  <!-- Marker -->
                  <l-marker v-if="position && position.lat && position.lng" visible draggable :icon="icon"
                    :lat-lng.sync="position" @dragstart="dragging = true" @dragend="dragging = false"></l-marker>
                </l-map>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
            class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelAddEditFunction()"
            class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="850" v-model="isFenceModalOpen">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-map mdi-22px</v-icon>
              <span class="modal-title-text mr-2">فنس بیمارستان</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-12">
          <v-row>
            <v-col cols="12">
              <div id="fanceMap">
                <l-map v-if="isFenceMapReadyToShow" ref="fancemap" style="height: 60vh !important" :zoom="fenceZoom"
                  :center="fenceCenter" :options="fanceMapOptions" @ready="fenceMapInvalidate">
                  <l-tile-layer :url="mapTileUrl" :attribution="attribution"></l-tile-layer>
                  <template v-if="polygonData?.length">
                    <l-polygon :lat-lngs="polygonData" :color="currentFenceColor"
                      :fillColor="currentFenceColor"></l-polygon>
                  </template>
                  <l-control position="bottomleft" v-if="toggleEditFlag == true">
                    <v-btn icon small tile class="no-letter-space" @click="toggleEditMode()" style="
                        background-color: white;
                        border: solid;
                        border-width: 2px;
                        border-radius: 5px;
                        border-color: #c2bfba;
                        padding: 15px;
                      ">
                      <v-icon>mdi-vector-polyline-edit</v-icon>
                    </v-btn>
                  </l-control>
                </l-map>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn dark rounded color="darkColor" class="normal-letter-spacing px-12" @click="addNewHospitalFence">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined class="normal-letter-spacing px-10"
            @click="closeHospitalFenceModal">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      <div></div>
    </v-dialog>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">مدیریت بیمارستان ها</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="3" class="mr-n11">
              <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense
                v-model="searchTitle" class="mt-3 mr-n16"></v-text-field>
            </v-col>
            <v-col cols="1" class="mr-n3">
              <v-btn class="mx-2 mt-3 mr-n16" fab dark small @click="showSearchModal()" color="darkColor" elevation="0">
                <v-icon dark>mdi-filter mdi-18px</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="1" class="mr-n16 mt-6" v-if="isSearch">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon light v-bind="attrs" v-on="on" @click="removeFilters()" class="mr-n16">
                    mdi-filter-remove mdi-18px
                  </v-icon>
                </template>
                <span>حذف فیلتر ها</span>
              </v-tooltip>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="2" class="text-left">
              <v-btn rounded color="darkColor" dark @click="enableAddEditFunction(1, 0)"
                class="mt-3 normal-letter-spacing ml-3">
                <v-icon class="ml-1">mdi-plus mdi-18px</v-icon>
                افزودن بیمارستان
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters class="background-main mx-2">
            <v-col cols="12">
              <v-card elevation="0" class="body-card card-width">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <template>
                        <v-data-table fixed-header :headers="hospitalManagmentInformationTableHeaders"
                          :items="hospitalFilteredList" :page.sync="page" :items-per-page="hospitalFilteredList.length"
                          height="62vh" :hide-default-footer="true" multi-sort class="elevation-0">
                          <template v-slot:[`item.actions`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1" color="iconColor" style="cursor: pointer"
                                  @click="showEditDiagnosisBaseDataModal(item.id)" v-bind="attrs" v-on="on">
                                  mdi-stethoscope
                                </v-icon>
                              </template>
                              <span>سانتر</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer"
                                  @click="openHospitalFenceModal(item.id)" v-bind="attrs" v-on="on">
                                  mdi-map
                                </v-icon>
                              </template>
                              <span>فنس</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer"
                                  @click="enableAddEditFunction(2, item.id)" v-bind="attrs" v-on="on">
                                  mdi-pencil
                                </v-icon>
                              </template>
                              <span>ویرایش</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer"
                                  @click="showDeleteConfirmFunction(item.id)" v-bind="attrs" v-on="on">
                                  mdi-delete
                                </v-icon>
                              </template>
                              <span>حذف</span>
                            </v-tooltip>
                          </template>
                          <template v-slot:no-data>
                            <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                          </template>
                        </v-data-table>
                      </template>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <pagination-component ref="pagination">
                <div slot="action">
                  <v-card elevation="0">
                    <v-pagination class="mt-8" circle v-model="page" color="lightColor" :length="totalPages"
                      :total-visible="8" :value="totalPages" prev-icon="mdi-chevron-left" next-icon="mdi-chevron-right"
                      @next="next()" @previous="previous()" @input="input()"></v-pagination>
                  </v-card>
                </div>
              </pagination-component>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import { latLng } from 'leaflet';
import L from 'leaflet';
import { LMap, LTileLayer, LMarker, LPolygon } from 'vue2-leaflet';

import 'leaflet/dist/leaflet.css';
import '@geoman-io/leaflet-geoman-free';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';
//import TableComponent from "../../components/TabelComponent.vue";
import confirmDialog from '../../components/ConfirmDialog.vue';
import AlertComponent from '../../components/AlertComponent.vue';
import PaginationComponent from '../../components/PaginationComponent.vue';
import SharedMap from '@/Mixins/map';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import pagination from '@/Mixins/Pagination';
import hospitalMixin from '@/Mixins/BaseInformation/HospitalMixin';
import cityMixin from '@/Mixins/BaseInformation/CityMixin';
import ServiceMixin from '@/Mixins/ServiceMixin';
import ProvinceMixin from '@/Mixins/BaseInformation/ProvinceMixin';
import hospitalHelper from '@/Helpers/BaseInformation/HospitalHelper';
import HospitalFenceHelper from '@/Helpers/BaseInformation/HospitalFence.helper';

import DiagnosisBaseDataMixin from '@/Mixins/BaseInformation/DiagnosisBaseDataMixin.js';
import HospitalFenceMixin from '@/Mixins/BaseInformation/HospitalFence.mixin';
export default {
  name: 'HospitalManagment',
  title: 'بیمارستان',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    confirmDialog,
    AlertComponent,
    PaginationComponent,
    LMap,
    LTileLayer,
    LMarker,
    LPolygon,
  },
  mixins: [
    pagination,
    ShearedMixin,
    hospitalMixin,
    hospitalHelper,
    snackBar,
    cityMixin,
    ServiceMixin,
    ProvinceMixin,
    ShearedHelper,
    DiagnosisBaseDataMixin,
    SharedMap,
    HospitalFenceMixin,
    HospitalFenceHelper,
  ],
  created() {
    this.$root.$refs.HospitalManagment = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {
      withPopup: latLng(30.2839, 57.0834),
      withTooltip: latLng(30.2839, 57.0834),
      currentZoom: 12,
      currentCenter: latLng(30.2839, 57.0834),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      fanceMapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      // fanceCenter: latLng(30.2839, 57.0834),
      fanceZoom: 5,
      position: null,
      dragging: false,
      icon: this.getIcon,
    };
  },
  methods: {
    mounte: function () {
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('@/assets/images/marker-icon-2x.png'),
        iconUrl: require('@/assets/images/marker-icon.png'),
        shadowUrl: require('@/assets/images/marker-shadow.png'),
      });
      // this.$refs.pagination.newPageSize = 10;
      // this.$refs.pagination.pageSize = 10;
      this.getListOfHospitalsWithPagination();
      this.getListOfCitysForOther();
      this.getListOfProvinces();
      this.setMapBaseSystemSetting();
      this.setFanceMapBaseSystemSetting();
    },
    previous: function () {
      this.getListOfHospitalsWithPagination();
      this.$refs.pagination.page = this.page;
    },
    next: function () {
      this.getListOfHospitalsWithPagination();
      this.$refs.pagination.page = this.page;
    },
    input: function () {
      this.getListOfHospitalsWithPagination();
      this.$refs.pagination.page = this.page;
    },
    //map
    centerUpdate(center) {
      this.currentCenter = center;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    mapInvalidate: function () {
      setTimeout(() => {
        this.$refs.modalmap.mapObject.invalidateSize();
      }, 100);
    },
    fenceMapInvalidate: function () {
      setTimeout(() => {
        this.$refs.fancemap.mapObject.invalidateSize();
      }, 100);
    },
    mapInvalidate2: function () {
      this.zoom = 15;
      setTimeout(() => {
        this.$refs.map.mapObject.invalidateSize();
      }, 100);
      setTimeout(() => {
        this.$refs.secondmap.mapObject.invalidateSize();
      }, 100);
    },
    addMarker(event) {
      this.position = event.latlng;
    },
  },
  computed: {
    fanceCenter() {
      const lat = this.$store.state.SystemSettingModule.systemSetting?.mapCenterLatitude;
      const lng = this.$store.state.SystemSettingModule.systemSetting?.mapCenterLongitude;

      return lat && lng ? [lat, lng] : [30.2839, 57.0834];
    },
    hospitalFilteredList() {
      return this.hospitalPaginationList.filter((u) => {
        return u.title.toLowerCase().includes(this.searchTitle.toLowerCase());
      });
    },
  },
};
</script>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.card-add-phoneNumber-items-text {
  color: #cdcbcf !important;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .card-add-phoneNumber {
    border: 2px solid #cdcbcf !important;
    height: 7vh !important;
  }

  .card-add-phoneNumber-items {
    margin-top: -10px !important;
  }

  .table-content {
    margin-top: 0vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .card-add-phoneNumber {
    border: 2px solid #cdcbcf !important;
    height: 7vh !important;
  }

  .table-content {
    margin-top: 0vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }

  .card-add-phoneNumber-items {
    margin-top: -10px !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }

  .card-add-phoneNumber {
    border: 2px solid #cdcbcf !important;
    height: 5.3vh !important;
  }

  .card-add-phoneNumber-items {
    margin-top: -7px !important;
  }
}

.inside-cards {
  border: 1px solid var(--dark-color) !important;
  overflow-y: auto !important;
}

.dialog-part-divider-text {
  color: #212121;
  font-size: 14px;
  font-weight: 600;
}

.chip-text {
  color: var(--dark-color) !important;
}
</style>
